import classnames from 'classnames';
import React from 'react';

import css from './defaultIconStyles.css';

export function IconCreateSnapshot({
    width = '16',
    height = '16',
    className,
    ...rest
}) {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg"
            className={classnames(css.main, className)}
            {...rest}
        >
            <path d="M 13 16 L 3 16 C 1.895 16 1 15.105 1 14 L 1 2 C 1 0.895 1.895 0 3 0 L 13 0 C 14.105 0 15 0.895 15 2 L 15 14 C 15 15.105 14.105 16 13 16 Z  M 12.002 11 L 3.998 11 C 3.446 11.001 3 11.448 3 12 L 3 13 C 3 13.552 3.446 13.999 3.998 14 L 12.002 14 C 12.554 13.999 13 13.552 13 13 L 13 12 C 13 11.448 12.554 11.001 12.002 11 L 12.002 11 Z  M 5 11.5 C 5.357 11.5 5.687 11.691 5.866 12.001 C 6.044 12.31 6.043 12.692 5.865 13.001 C 5.686 13.31 5.355 13.5 4.998 13.5 C 4.446 13.499 3.998 13.051 3.999 12.499 C 4 11.947 4.448 11.499 5 11.5 L 5 11.5 Z  M 8 11.5 C 8.357 11.5 8.687 11.691 8.866 12.001 C 9.044 12.31 9.043 12.692 8.865 13.001 C 8.686 13.31 8.355 13.5 7.998 13.5 C 7.446 13.499 6.998 13.051 6.999 12.499 C 7 11.947 7.448 11.499 8 11.5 L 8 11.5 Z  M 3.507 9 L 12.485 9 C 12.765 9 12.992 8.767 12.992 8.48 L 13 3.04 C 13 2.466 12.546 2 11.985 2 L 4.023 2 C 3.463 2 3.008 2.466 3.008 3.04 L 3 8.48 C 3 8.767 3.227 9 3.507 9 Z" />
        </svg>
    );
}

export default IconCreateSnapshot;
